import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';

class BreadCumb extends Component {

    render() {
        const {subitem1}=this.props;
        const {url1}=this.props;
        if(!subitem1){$('.subItemBread').hide();}//si no llegan subitems oculta los elementos
        return (
            <nav aria-label="breadcrumb" style={{marginLeft: "3.2rem",marginTop:"6rem",maxWidth:'99%'}}>
                <ol className="breadcrumb">
                    <Link to="/" className="breadcrumb-item text-dark"><strong>DASHBOARD</strong></Link>
                    <Link to={url1} className="breadcrumb-item text-muted subItemBread" aria-current="page">{subitem1}</Link>

                </ol>
            </nav>
        );
    }
}

export default BreadCumb;
